import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=fd3b93da&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=fd3b93da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3b93da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd3b93da')) {
      api.createRecord('fd3b93da', component.options)
    } else {
      api.reload('fd3b93da', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=fd3b93da&scoped=true&", function () {
      api.rerender('fd3b93da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2h29JVzFFrSgZ/JS/comp/DocBox.vue"
export default component.exports